import { h$1 as T, me as B, h as f, a as k, u$1 as $, c as O, Y as h, v as g, m as _, o as L } from "../chunks/register-Ba9sFUKZ.js";
import * as C from "react";
import { d as I } from "../chunks/query-DoAo5UXi.js";
import { l as x } from "../chunks/query-all-_71klivX.js";
import { u as U } from "../chunks/class-map-B8OdeXIO.js";
import { o as A } from "../chunks/map-gLOTYKyP.js";
import { o as u } from "../chunks/unsafe-svg-CXadf7rM.js";
import { S as E } from "../chunks/whiteSpaceSensitive-57hmOJgN.js";
import { c as z } from "../chunks/addListRole-81gRkw1n.js";
import { c as G, f as S } from "../chunks/lifecycle-decorators-C04d1yHY.js";
/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */
function* F(e, t, n = 1) {
  const c = t === void 0 ? 0 : e;
  t != null || (t = e);
  for (let r = c; n > 0 ? r < t : t < r; r += n) yield r;
}
const M = `<svg xmlns="http://www.w3.org/2000/svg" slot="icon" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path d="M16 8L12 12L16 16" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M8 8V16" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`, D = `<svg xmlns="http://www.w3.org/2000/svg" slot="icon" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path d="M8 8L12 12L8 16" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M16 8V16" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`, K = `<svg xmlns="http://www.w3.org/2000/svg" slot="icon" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path d="M14 16L10 12L14 8" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`, j = `<svg xmlns="http://www.w3.org/2000/svg" slot="icon" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path d="M10 8L14 12L10 16" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`, o = {
  beaconTagName: "beacon-pagination",
  ICON_BUTTON_TAG: "beacon-icon-button",
  PAGINATION_BUTTON_TAG: "beacon-pagination-button"
}, V = T`.visually-hidden{border:0;clip:rect(0,0,0,0);block-size:1px;margin:-1px;overflow:hidden;padding:0;position:absolute;inline-size:1px}:host{--override-icon-button-block-size: var(--beacon-reference-space-7);--override-icon-button-inline-size: var(--beacon-reference-space-7);--override-icon-button-border-radius: var(--beacon-system-radius-corner-standard);--override-icon-button-wrapper-block-size: var(--beacon-reference-space-7);--override-icon-button-wrapper-inline-size: var(--beacon-reference-space-7);--override-icon-button-display: flex}@media (width >= 640px){:host{--override-icon-button-block-size: var(--beacon-reference-space-8);--override-icon-button-inline-size: var(--beacon-reference-space-8);--override-icon-button-wrapper-block-size: var(--beacon-reference-space-8);--override-icon-button-wrapper-inline-size: var(--beacon-reference-space-8)}}@media (width >= 1280px){:host{--override-icon-button-block-size: var(--beacon-reference-space-9);--override-icon-button-inline-size: var(--beacon-reference-space-9);--override-icon-button-wrapper-block-size: var(--beacon-reference-space-9);--override-icon-button-wrapper-inline-size: var(--beacon-reference-space-9)}}:host .base{align-items:center;display:flex;gap:var(--beacon-reference-space-3)}:host .base.on-first .previous,:host .base.on-first .first{display:none}:host .base.on-last .next,:host .base.on-last .last{display:none}:host .base.input .search-wrapper{align-items:center;display:flex;gap:var(--beacon-reference-space-3)}:host .base.input .total-pages{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-body-100);text-wrap:nowrap}:host .base.input input{font:var(--beacon-system-font-weight-light) var(--beacon-system-font-size-sans-serif-body-100);background-color:var(--beacon-system-color-background-1);block-size:var(--beacon-reference-space-9);border:var(--beacon-system-width-border-mini) solid var(--beacon-component-form-color-border-standard);border-radius:var(--beacon-system-radius-corner-standard);color:var(--beacon-system-color-text-standard);inline-size:var(--beacon-reference-space-10);text-align:center}:host .base.input input:focus-visible{outline:var(--beacon-system-width-border-normal) solid var(--beacon-system-color-border-focus-middle);outline-offset:var(--beacon-system-width-border-normal);position:relative;z-index:1}:host .pagination-buttons,:host ::slotted(ol){align-items:center;display:flex;gap:var(--beacon-reference-space-3);list-style:none;margin:0;padding:0}:host .number-input{-webkit-appearance:textfield;-moz-appearance:textfield;appearance:textfield}:host .number-input::-webkit-inner-spin-button,:host .number-input::-webkit-outer-spin-button{-webkit-appearance:none;-moz-appearance:none;appearance:none}:host .truncated{display:none}:host .truncated:has(+.last-page){display:revert}:host .first-page+.truncated,:host:has(+.last-page){display:revert}`;
var w = (e) => {
  throw TypeError(e);
}, N = (e, t, n) => t.has(e) || w("Cannot " + n), P = (e, t, n) => (N(e, t, "read from private field"), n ? n.call(e) : t.get(e)), y = (e, t, n) => t.has(e) ? w("Cannot add the same private member more than once") : t instanceof WeakSet ? t.add(e) : t.set(e, n), l = (e, t, n, c) => (N(e, t, "write to private field"), t.set(e, n), n), R = Object.defineProperty, W = Object.getOwnPropertyDescriptor, s = (e, t, n, c) => {
  for (var r = c > 1 ? void 0 : c ? W(t, n) : t, b = e.length - 1, m; b >= 0; b--)
    (m = e[b]) && (r = (c ? m(t, n, r) : m(r)) || r);
  return c && r && R(t, n, r), r;
}, p, d, a;
const i = (a = class extends B {
  constructor() {
    super(...arguments), y(this, p), y(this, d), this.beaconTagName = o.beaconTagName, this.variant = "default", l(this, d, 1), this.pageUpdatedByNavigation = !1, this.isKeyboardNavigation = !1, this.handleKeyDown = () => {
      this.isKeyboardNavigation = !0;
    }, this.handleMouseDown = () => {
      this.isKeyboardNavigation = !1;
    };
  }
  static get styles() {
    return [super.styles, V];
  }
  get pages() {
    return P(this, p);
  }
  set pages(e) {
    l(this, p, e), this.currentPage > this.pages && (this.pageUpdatedByNavigation = !1, this.currentPage = this.pages);
  }
  get currentPage() {
    return P(this, d);
  }
  set currentPage(e) {
    e > this.totalPages ? (a.pageCountErrorLog(), l(this, d, 1)) : P(this, d) !== e && (l(this, d, Number(e)), $(this, O.CHANGE, {
      detail: {
        page: this.currentPage,
        interaction: this.pageUpdatedByNavigation
      }
    }), this.variant === "default" && (this.resetCurrentPage(), this.setCurrentPage()));
  }
  // doesn't use a query decorator since we're looking at child elements of a list
  get slottedPaginationButtons() {
    return Array.from(
      this.querySelectorAll('[beacon-tag-name="beacon-pagination-button"]')
    );
  }
  get inUsePaginationButtons() {
    return this.slottedPaginationButtons.length > 0 ? this.slottedPaginationButtons : this.paginationButtons;
  }
  get totalPages() {
    return this.slottedPaginationButtons.length > 0 ? this.slottedPaginationButtons.length : this.pages;
  }
  get isOnLastPage() {
    return this.currentPage === this.totalPages;
  }
  get isOnFirstPage() {
    return this.currentPage === 1;
  }
  static pageCountErrorLog() {
    console.log(
      "Beacon Pagination tried to set a current page that is out of range of possible pages."
    );
  }
  incrementPage() {
    this.pageUpdatedByNavigation = !0, this.currentPage++, this.isOnLastPage && this.handleOnLastPage();
  }
  decrementPage() {
    this.pageUpdatedByNavigation = !0, this.currentPage--, this.isOnFirstPage && this.handleOnFirstPage();
  }
  skipToFirstPage() {
    this.pageUpdatedByNavigation = !0, this.currentPage = 1, this.handleOnFirstPage();
  }
  skipToLastPage() {
    this.pageUpdatedByNavigation = !0, this.currentPage = this.pages, this.handleOnLastPage();
  }
  handleOnFirstPage() {
    this.isKeyboardNavigation && (this.variant === "input" ? this.searchField.focus() : this.inUsePaginationButtons[0].focus());
  }
  handleOnLastPage() {
    this.isKeyboardNavigation && (this.variant === "input" ? this.searchField.focus() : this.inUsePaginationButtons[this.inUsePaginationButtons.length - 1].focus());
  }
  resetCurrentPage() {
    const e = this.inUsePaginationButtons, t = Array.from(e).find(
      (n) => n._current
    );
    t && (t._current = !1);
  }
  setCurrentPage() {
    const e = this.inUsePaginationButtons[this.currentPage - 1];
    e && (e._current = !0, e._isLink && this.pageUpdatedByNavigation && e._slottedLink.click());
  }
  handlePaginateEvent(e) {
    this.pageUpdatedByNavigation = !1, this.currentPage = e.detail.page;
  }
  handleDefaultSlotchange() {
    if (this.resetCurrentPage(), this.slottedPaginationButtons.forEach(
      (e, t) => {
        e._value = t + 1;
      }
    ), this.currentPage > this.totalPages)
      a.pageCountErrorLog(), this.currentPage = 1;
    else {
      const e = this.inUsePaginationButtons[this.currentPage - 1];
      e && !e._current && (e._current = !0);
    }
  }
  static renderPaginationButtonListItem(e, t) {
    return h`<li class="${e}">${t}</li>`;
  }
  /**
   * Renders all the buttons in a pagination. Only the necessary pages are shown untruncated.
   *
   * Logic works as follows:
   *
   * - Current page visible
   * - First page visible
   * - Last page visible
   * - Previous page visible
   * - Next page visible
   * - Third page visible if the first page is the current page
   * - Third to last page visible if the last page is the current page
   */
  generateButtons() {
    return h`
      <ol class="pagination-buttons" role="list">
        ${A(F(this.pages), (e) => {
      const t = e + 1, n = g`
            <${this.getScopedTag(o.PAGINATION_BUTTON_TAG)}
              ._value="${t}"
              ._current=${this.currentPage === t}
              ._totalPageCount=${this.totalPages}
            ></${this.getScopedTag(o.PAGINATION_BUTTON_TAG)}>
          `;
      return t === this.currentPage ? a.renderPaginationButtonListItem(
        "current-page",
        n
      ) : t === this.currentPage - 1 ? a.renderPaginationButtonListItem(
        "previous-page",
        n
      ) : t === this.currentPage + 1 ? a.renderPaginationButtonListItem(
        "next-page",
        n
      ) : t === 1 ? a.renderPaginationButtonListItem(
        "first-page",
        n
      ) : t === this.pages ? a.renderPaginationButtonListItem(
        "last-page",
        n
      ) : this.isOnFirstPage && t === 3 ? a.renderPaginationButtonListItem(
        "third-page",
        n
      ) : this.isOnLastPage && t === this.pages - 2 ? a.renderPaginationButtonListItem(
        "third-last-page",
        n
      ) : a.renderPaginationButtonListItem(
        "truncated",
        g`<${this.getScopedTag(o.PAGINATION_BUTTON_TAG)} is-truncating></${this.getScopedTag(o.PAGINATION_BUTTON_TAG)}>`
      );
    })}
      </ol>
    `;
  }
  // TODO: replace all these with their respective icons
  renderPreviousPageButton() {
    return g`<${this.getScopedTag(o.ICON_BUTTON_TAG)} @beacon-event-click=${this.decrementPage} variant="tertiary"
      >Previous page${u(K)}
    </${this.getScopedTag(o.ICON_BUTTON_TAG)}>`;
  }
  renderNextPageButton() {
    return g`<${this.getScopedTag(o.ICON_BUTTON_TAG)} @beacon-event-click=${this.incrementPage} variant="tertiary"
      >Next page${u(j)}
    </${this.getScopedTag(o.ICON_BUTTON_TAG)}>`;
  }
  renderFirstPageButton() {
    return g`<${this.getScopedTag(o.ICON_BUTTON_TAG)} @beacon-event-click=${this.skipToFirstPage} variant="tertiary"
      >Skip to first page${u(M)}
    </${this.getScopedTag(o.ICON_BUTTON_TAG)}>`;
  }
  renderLastPageButton() {
    return g`<${this.getScopedTag(o.ICON_BUTTON_TAG)} @beacon-event-click=${this.skipToLastPage} variant="tertiary"
      >Skip to last page${u(D)}
    </${this.getScopedTag(o.ICON_BUTTON_TAG)}>`;
  }
  // slotted link clicks do not emit beacon-event-paginate because they are links to new pages
  renderDefaultVariant() {
    return h`
      <div class="previous">${this.renderPreviousPageButton()}</div>
      <nav class="main" aria-labelledby="title">
        <span class="visually-hidden" id="title"
          ><slot name="title">Pagination</slot></span
        >
        <slot
          ${E()}
          @beacon-event-paginate=${this.handlePaginateEvent}
          @slotchange=${z(this.handleDefaultSlotchange.bind(this))}
          >${this.generateButtons()}</slot
        >
      </nav>
      <div class="next">${this.renderNextPageButton()}</div>
    `;
  }
  handleInputKeydown(e) {
    if (e.key === "Enter") {
      const t = parseInt(this.searchField.value, 10);
      !isNaN(t) && t >= 1 && t <= this.pages ? this.currentPage = t : this.searchField.value = String(this.currentPage);
    }
  }
  renderInputVariant() {
    return h`
      <div class="first">${this.renderFirstPageButton()}</div>
      <div class="previous">${this.renderPreviousPageButton()}</div>
      <search class="search-wrapper">
        <label for="search" class="visually-hidden">
          <slot name="search-label">Enter page number</slot>
        </label>
        <input
          class="skip-focus-override number-input"
          id="search"
          name="search"
          aria-describedby="total-pages"
          type="number"
          min="1"
          max="${this.pages}"
          inputmode="numeric"
          .value=${this.currentPage}
          @keydown=${this.handleInputKeydown} />
        <span id="total-pages" class="total-pages">of ${this.pages}</span>
      </search>
      <div class="next">${this.renderNextPageButton()}</div>
      <div class="last">${this.renderLastPageButton()}</div>
    `;
  }
  renderMainContent() {
    return this.variant === "input" ? this.renderInputVariant() : this.renderDefaultVariant();
  }
  registerNavigation() {
    this.addEventListener("keydown", this.handleKeyDown), this.addEventListener("mousedown", this.handleMouseDown);
  }
  tearDownNavigation() {
    this.removeEventListener("keydown", this.handleKeyDown), this.removeEventListener("mousedown", this.handleMouseDown);
  }
  render() {
    const e = {
      base: !0,
      "on-first": this.isOnFirstPage,
      "on-last": this.isOnLastPage
    };
    return e[this.variant] = !0, h`<div class="${U(e)}">
      ${this.renderMainContent()}
    </div>`;
  }
}, p = /* @__PURE__ */ new WeakMap(), d = /* @__PURE__ */ new WeakMap(), a.nestedComponents = ["beacon-pagination-button", "beacon-icon-button"], a.tagName = o.beaconTagName, a.shadowRootOptions = {
  ...B.shadowRootOptions,
  delegatesFocus: !1
}, a);
s([
  f({ type: Number })
], i.prototype, "pages", 1);
s([
  f()
], i.prototype, "variant", 2);
s([
  f({ type: Number, attribute: "current-page", reflect: !0 })
], i.prototype, "currentPage", 1);
s([
  k()
], i.prototype, "pageUpdatedByNavigation", 2);
s([
  I("input")
], i.prototype, "searchField", 2);
s([
  x('[beacon-tag-name="beacon-pagination-button"]')
], i.prototype, "paginationButtons", 2);
s([
  G
], i.prototype, "registerNavigation", 1);
s([
  S
], i.prototype, "tearDownNavigation", 1);
let v = i;
const ne = (e) => (_(e, v), L({
  tagName: e ? e + "-" + v.tagName : v.tagName,
  elementClass: v,
  react: C,
  events: {
    onBeaconEventChange: "beacon-event-change",
    onBeaconEventRenderActionZone: "beacon-event-render-action-zone",
    onBeaconEventInput: "beacon-event-input",
    onBeaconEventFocus: "beacon-event-focus",
    onBeaconEventBlur: "beacon-event-blur",
    onBeaconEventClick: "beacon-event-click",
    onBeaconEventMousedown: "beacon-event-mousedown",
    onBeaconEventKeydown: "beacon-event-keydown",
    onBeaconEventRender: "beacon-event-render",
    onBeaconEventDeferredChild: "beacon-event-deferred-child",
    onBeaconEventMouseenter: "beacon-event-mouseenter",
    onBeaconEventMouseleave: "beacon-event-mouseleave",
    onBeaconEventHide: "beacon-event-hide"
  }
}));
export {
  ne as default,
  ne as reactBeaconPagination
};
